export const errorStyles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      textAlign: 'center',
      padding: '20px',
      backgroundColor: '#ffffff'
    },
  
    illustration: {
      maxWidth: '300px',
      marginBottom: '30px',
      width: '100%',
      height: 'auto'
    },
  
    heading: {
      color: '#343f52',
      marginBottom: '20px',
      fontSize: '2rem',
      fontWeight: '600',
      lineHeight: '1.35'
    },
  
    message: {
      color: '#60697b',
      marginBottom: '30px',
      maxWidth: '600px',
      fontSize: '1rem',
      lineHeight: '1.5'
    },
  
    buttonContainer: {
      display: 'flex',
      gap: '15px',
      marginTop: '20px'
    },
  
    primaryButton: {
      padding: '10px 20px',
      backgroundColor: '#ff8264',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '1rem',
      fontWeight: '500',
      transition: 'background-color 0.2s ease',
      '&:hover': {
        backgroundColor: '#4a46a8'
      }
    },
  
    secondaryButton: {
      padding: '10px 20px',
      backgroundColor: 'transparent',
      color: '#ff8264',
      border: '1px solid #ff8264',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '1rem',
      fontWeight: '500',
      transition: 'all 0.2s ease',
      '&:hover': {
        backgroundColor: '#f8f7ff',
        borderColor: '#4a46a8'
      }
    },
  
    errorDetails: {
      marginTop: '30px',
      textAlign: 'left',
      width: '100%',
      maxWidth: '800px'
    },
  
    errorSummary: {
      cursor: 'pointer',
      padding: '10px',
      color: '#ff8264',
      fontWeight: '500',
      '&:hover': {
        color: '#4a46a8'
      }
    },
  
    errorStack: {
      backgroundColor: '#f8f9fa',
      padding: '15px',
      borderRadius: '4px',
      marginTop: '10px',
      whiteSpace: 'pre-wrap',
      overflow: 'auto',
      maxHeight: '200px',
      border: '1px solid #e9ecef',
      fontSize: '0.875rem',
      lineHeight: '1.5'
    },
  
    errorMessage: {
      color: '#dc3545',
      marginBottom: '10px',
      fontFamily: 'monospace',
      fontSize: '0.875rem'
    },
  
    // Responsive styles
    '@media (max-width: 768px)': {
      container: {
        padding: '15px'
      },
      illustration: {
        maxWidth: '200px'
      },
      heading: {
        fontSize: '1.5rem'
      },
      buttonContainer: {
        flexDirection: 'column',
        width: '100%',
        maxWidth: '300px'
      },
      primaryButton: {
        width: '100%'
      },
      secondaryButton: {
        width: '100%'
      }
    },
  
    '@media (max-width: 480px)': {
      illustration: {
        maxWidth: '150px'
      },
      heading: {
        fontSize: '1.25rem'
      },
      message: {
        fontSize: '0.875rem'
      }
    },
  
    // Dark mode support
    '@media (prefers-color-scheme: dark)': {
      container: {
        backgroundColor: '#1a1a1a'
      },
      heading: {
        color: '#ffffff'
      },
      message: {
        color: '#cccccc'
      },
      errorStack: {
        backgroundColor: '#2d2d2d',
        borderColor: '#404040'
      },
      secondaryButton: {
        borderColor: '#ff8264',
        color: '#ff8264',
        '&:hover': {
          backgroundColor: 'rgba(96, 93, 186, 0.1)'
        }
      }
    },
  
    // Animation styles
    fadeIn: {
      animation: 'fadeIn 0.5s ease-in',
      '@keyframes fadeIn': {
        '0%': {
          opacity: 0,
          transform: 'translateY(-20px)'
        },
        '100%': {
          opacity: 1,
          transform: 'translateY(0)'
        }
      }
    },
  
    // Accessibility styles
    focusOutline: {
      '&:focus': {
        outline: '2px solid #ff8264',
        outlineOffset: '2px'
      }
    }
  };